import _sum from 'lodash/sum';
import { TPOStatus, TPOStatusOption } from 'volta/models/types/planning-order';

import Component from '@glimmer/component';
import { indexByFn } from 'volta/utils/array-utils';

interface IArgs {
  options: TPOStatusOption[];
  linkRoute?: string;
  linkQueryGetter?: (key: TPOStatus) => Record<string, string | number>;
}

export default class POStatusGraph extends Component<IArgs> {
  get totalStatusCount() {
    const { options } = this.args;
    return _sum(options.map((o) => o.count));
  }

  get indexedOptions() {
    return indexByFn(this.args.options, (o) => o.key);
  }

  getPercentage = (key: TPOStatus) => {
    const { indexedOptions } = this;
    const statusCount = indexedOptions[key].count ?? 0;

    return this.totalStatusCount == 0 ? 0 : ((statusCount / this.totalStatusCount) * 100).toFixed();
  };
}
